import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(amount, currency = "USD") {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
}

export function formatDate(dateString) {
  return new Date(dateString).toLocaleDateString("en-US", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function formatTime(dateString) {
  return new Date(dateString).toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function getTimeSince(dateString) {
  const now = new Date();
  const date = new Date(dateString);
  const diffMs = now - date;
  const diffMins = Math.floor(diffMs / 60000);
  
  if (diffMins < 1) return "Just now";
  if (diffMins < 60) return `${diffMins}m ago`;
  
  const diffHours = Math.floor(diffMins / 60);
  if (diffHours < 24) return `${diffHours}h ago`;
  
  return formatDate(dateString);
}

export function generateOrderNumber() {
  const now = new Date();
  const dateStr = now.toISOString().slice(0, 10).replace(/-/g, "");
  const random = Math.floor(Math.random() * 10000).toString().padStart(4, "0");
  return `${dateStr}-${random}`;
}

export const ORDER_STATUSES = {
  new: { label: "New", color: "bg-blue-100 text-blue-700", dotColor: "bg-blue-500" },
  preparing: { label: "Preparing", color: "bg-amber-100 text-amber-700", dotColor: "bg-amber-500" },
  ready: { label: "Ready", color: "bg-green-100 text-green-700", dotColor: "bg-green-500" },
  completed: { label: "Completed", color: "bg-gray-100 text-gray-700", dotColor: "bg-gray-500" },
  cancelled: { label: "Cancelled", color: "bg-red-100 text-red-700", dotColor: "bg-red-500" },
};

export const PAYMENT_STATUSES = {
  unpaid: { label: "Unpaid", color: "bg-red-100 text-red-700" },
  pending: { label: "Pending", color: "bg-yellow-100 text-yellow-700" },
  paid: { label: "Paid", color: "bg-green-100 text-green-700" },
  failed: { label: "Failed", color: "bg-red-100 text-red-700" },
  refunded: { label: "Refunded", color: "bg-orange-100 text-orange-700" },
};
